import React from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useTheme } from "../../context/ThemeContext";

import VideoGrid from "../shared/videoGrid";

import RelatedBg from "../../images/testimonials_people_bg.jpeg";
import DarkRelatedBg from "../../images/darkTestimonialsBg.png";
import TeenDarkRelatedBg from "../../images/fundraising/referral-background.png";

const TestimonialSection = ({
  genTestimonialVideos,
  sectionContainerStyles = "flex flex-col items-center justify-center mx-auto relative z-10 h-feature",
  sliderSpaceBetween = 10,
  sliderSlidesPerView = 1.1,
  sliderPagination = false,
  isTeenPage
}) => {
  const breakpoint = useBreakpoint();
  const { colorMode } = useTheme();

  const testimonialVideos = genTestimonialVideos ?? [];
  const testimonialCollection = testimonialVideos?.map((testimonial, index) => {
    return {
      ...testimonial,
      cardClass: "h-102 pb-16 sm:pb-0"
    };
  });

  return (
    <>
      <section
        className={`${sectionContainerStyles} ${
          isTeenPage ? " bg-gray-tertiary dark:bg-black" : ""
        }`}
      >
        <div
          className={`w-full z-0 top-0 bottom-0 right-0 left-0 bg-cover bg-no-repeat bg-center h-full ${isTeenPage ? " absolute " : ""}`}
          style={{
            backgroundImage: `url('${
              colorMode === "light"
                ? RelatedBg
                : isTeenPage
                  ? TeenDarkRelatedBg
                  : DarkRelatedBg
            }')`
          }}
        />

        <div className="w-11/12 sm:w-full sm:h-full sm:absolute top-0 m-0 flex flex-col items-center z-20">
          <div className="w-full sm:absolute sm:-translate-y-1/2 flex flex-col sm:w-8/12 shadow-md">
            <div className="flex flex-col w-full justify-start sm:justify-center sm:mx-auto py-12 sm:pr-0 sm:py-2 sm:h-24 sm:bg-white sm:dark:bg-gray-darkest">
              <h1
                className="font-light text-left text-title font-normal sm:text-center sm:text-[38px] leading-8 text-white sm:text-black-lighter dark:sm:text-white"
                dangerouslySetInnerHTML={{
                  __html: "Testimonials"
                }}
              />
            </div>
          </div>

          <div className="flex flex-col w-full sm:w-7/12 container mx-auto sm:py-32 testimonial-grid-swiper">
            <VideoGrid
              key={`featured-testimonial-video-grid`}
              cardOption={"social"}
              containerClass={"rounded-md block h-full "}
              gridClass={"w-full grid-cols-1 sm:grid-cols-3 sm:gap-4"}
              videos={testimonialCollection}
              conditionalSliderOpts={{
                condition: breakpoint === "xs",
                slidesPerView: sliderSlidesPerView,
                spaceBetween: sliderSpaceBetween,
                centeredSlides: false,
                className: "w-full h-full",
                pagination: sliderPagination
              }}
              instagramIconColor="white"
              socialClass={
                "grid grid-rows-1 grid-flow-col gap-0 justify-end row-span-0 gap-2 items-center "
              }
              socialImageClass={"w-8 h-8"}
              extraSocialNameTextClass={
                "font-alice dark:font-body font-semibold text-mob md:text-xl text-white col-span-5"
              }
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialSection;
